module.exports = __webpack_public_path__ + "static/media/img1.139c04ca.png";